import { render, staticRenderFns } from "./TrucksInvoices.vue?vue&type=template&id=786b8958&"
import script from "./TrucksInvoices.vue?vue&type=script&lang=js&"
export * from "./TrucksInvoices.vue?vue&type=script&lang=js&"
import style0 from "./TrucksInvoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports